import { productGallery } from '../snippets/product-gallery';
import ProductPageInfo from '../snippets/product-info';
import { initFaqAccordion } from '../sections/faq';
import { productSuggestionsSlider } from '../sections/product-suggestions';
import { initializeStickyButton } from '../snippets/sticky-button';

const galleryInstance = productGallery();

galleryInstance.init();
ProductPageInfo.initializeEvents();
initFaqAccordion();
productSuggestionsSlider();
initializeStickyButton();
